import * as React from "react";
import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";
const PREFIX = "ViewInstitutionModalSubtitle";

const classes = {
  viewInstitutionButton: `${PREFIX}-viewInstitutionButton`,
};

const StyledButton = styled(Button)(({ theme }) => ({
  [`&.${classes.viewInstitutionButton}`]: {
    position: "absolute",
    right: theme.spacing(1),
    textTransform: "none",
    margin: "0px 16px 10px 0px",

    [theme.breakpoints.down("sm")]: {
      position: "relative",
      right: "auto",
      margin: "8px 0 0 0",
    },
  },
}));

interface Props {
  onClick: () => void;
}

export default function ViewInstitutionModalSubtitle({ onClick }: Props) {
  return (
    <StyledButton
      id="view-institution-details-button"
      onClick={onClick}
      className={classes.viewInstitutionButton}
      variant="outlined"
      color="primary"
      size={"small"}
    >
      View Institution Details
    </StyledButton>
  );
}
